import { render, staticRenderFns } from "./createMemorialHall.vue?vue&type=template&id=2abc2766&scoped=true"
import script from "./createMemorialHall.vue?vue&type=script&lang=js"
export * from "./createMemorialHall.vue?vue&type=script&lang=js"
import style0 from "./createMemorialHall.vue?vue&type=style&index=0&id=2abc2766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abc2766",
  null
  
)

export default component.exports